module.exports = __webpack_public_path__ + "teqbahn-assets/media/1.9b510e73.jpg";